import React from 'react';
import { Link } from 'react-router-dom'
import './Logo.css';
import { view } from 'react-easy-state';

export default view((props) => (
  <Link to="/" className={
    "logo " +
    (props.className ? props.className : '')
  }>{props.children}</Link>
))